import type { CreatedApiKeyBodyType, GetApiKeyType } from "@whatslly/types/integrations/api-keys/ApiKey";
import { TFunction } from "i18next";
import { IPromiseBasedObservable } from "mobx-utils";

export const IApiKeysStore = Symbol.for("IApiKeysStore");

export interface IApiKeysStore {
  keyPair: CreatedApiKeyBodyType | undefined;
  keys: IPromiseBasedObservable<GetApiKeyType[]>;
  baseUrl: IPromiseBasedObservable<string>;
  loading: boolean;
  keysUpdating: boolean;
  refresh(): void;
  openCreateApiKeyModal(): Promise<void>;
  createApiKey(params: { apiKeyName: string; t: TFunction }): Promise<CreatedApiKeyBodyType | undefined>;
  revokeApiKey(params: { apiKey: string; t: TFunction }): Promise<void>;
}
